import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  PollResponseEdit,
  PollsEdit,
  PollsPage,
  PollsResponses,
  PollsResults,
} from '../pages/CMSPages/index';
import React from 'react';

const PollsRoutes = () => (
  <>
    <Route
      path={`${routes.cmsPolls}`}
      element={
        <CMSWrapper>
          <PollsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsPollEdit}/:id`}
      element={
        <CMSWrapper permissions={['polls.index']}>
          <PollsEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsPollResults}/:id`}
      element={
        <CMSWrapper permissions={['polls.index']}>
          <PollsResults />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsPollCreate}`}
      element={
        <CMSWrapper permissions={['departments.store']}>
          <PollsEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsResponseCollections}
      element={
        <CMSWrapper permissions={['response-collections.index']}>
          <PollsResponses />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsResponseCollectionsEdit}/:id`}
      element={
        <CMSWrapper permissions={['response-collections.show']}>
          <PollResponseEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsResponseCollectionsCreate}
      element={
        <CMSWrapper permissions={['response-collections.store']}>
          <PollResponseEdit mode={'create'} />{' '}
        </CMSWrapper>
      }
    />
  </>
);

export default PollsRoutes;
